// Helper function to get relevant theme suggestions based on subject and grade level
export function getThemeSuggestions(subject, gradeLevel) {
  // Early years themes (nursery through Year 2)
  if (['nursery', 'preK', 'kindergarten', 'grade1', 'grade2'].includes(gradeLevel)) {
    switch (subject) {
      case 'Mathematics':
        return [
          "Could the lesson be themed around a 'fruit basket' or 'sharing a cake'?",
          "How about using a treasure hunt theme for counting activities?",
          "Consider using farm animals for grouping and sorting exercises."
        ];
      case 'Science':
      case 'Biology':
        return [
          "Could you incorporate a garden or growing plants theme?",
          "How about framing the lesson around caring for pets?",
          "Consider using weather or seasons as a theme for exploration."
        ];
      case 'English':
      case 'Literature':
        return [
          "Could the lesson revolve around a favorite storybook character?",
          "How about using a fairy tale theme for storytelling activities?",
          "Consider framing writing activities around a teddy bears' picnic."
        ];
      default:
        return [
          "Could the lesson be themed around familiar characters from stories?",
          "How about incorporating animals or nature themes?",
          "Consider using everyday experiences like shopping or family activities."
        ];
    }
  }
  // Middle primary years (Years 3-6)
  else if (['grade3', 'grade4', 'grade5', 'grade6'].includes(gradeLevel)) {
    switch (subject) {
      case 'Mathematics':
        return [
          "Could the lesson use a space exploration theme for measurement?",
          "How about a shopping or market theme for money problems?",
          "Consider using sports statistics or scores for data handling."
        ];
      case 'Science':
      case 'Biology':
      case 'Chemistry':
      case 'Physics':
        return [
          "Could the lesson be framed as a detective investigation?",
          "How about using a time travel theme to explore changes?",
          "Consider using survival on a desert island for practical applications."
        ];
      case 'History':
      case 'SocialStudies':
        return [
          "Could the lesson involve a time machine journey to the period?",
          "How about framing it as archaeological discoveries?",
          "Consider using a museum exhibition theme for presentations."
        ];
      default:
        return [
          "Could the lesson incorporate popular interests like sports or games?",
          "How about using adventure or exploration themes?",
          "Consider connecting to real-world problems students might recognize."
        ];
    }
  }
  // Secondary years (Years 7+)
  else if (['grade7', 'grade8', 'grade9', 'grade10', 'grade11', 'grade12'].includes(gradeLevel)) {
    switch (subject) {
      case 'Mathematics':
        return [
          "Could the lesson use real-world applications like architecture or engineering?",
          "How about connecting to financial literacy through budgeting scenarios?",
          "Consider using data from current events or social media trends."
        ];
      case 'Science':
      case 'Biology':
      case 'Chemistry':
      case 'Physics':
        return [
          "Could the lesson connect to current environmental challenges?",
          "How about framing experiments around forensic investigation?",
          "Consider using themes from popular science fiction for theoretical concepts."
        ];
      case 'History':
      case 'SocialStudies':
      case 'Geography':
        return [
          "Could the lesson use documentary filmmaking as a framework?",
          "How about simulating a historical debate or conference?",
          "Consider using current events that connect to historical patterns."
        ];
      case 'ComputerScience':
        return [
          "Could the lesson be framed around developing an app for a specific problem?",
          "How about using game design principles to teach concepts?",
          "Consider connecting programming to social media or current technology trends."
        ];
      default:
        return [
          "Could the lesson incorporate current events or media references?",
          "How about connecting to career pathways or real-world applications?",
          "Consider using collaborative projects with real audiences or purposes."
        ];
    }
  }
  // Higher education and adult learning
  else {
    return [
      "Could the content be framed within professional case studies?",
      "How about connecting theories to current industry practices?",
      "Consider using problem-based scenarios relevant to career development."
    ];
  }
}